import { render, staticRenderFns } from "./assignments-grid.vue?vue&type=template&id=4b83a202&scoped=true&"
import script from "./assignments-grid.ts?vue&type=script&lang=ts&"
export * from "./assignments-grid.ts?vue&type=script&lang=ts&"
import style0 from "./assignments-grid.scss?vue&type=style&index=0&id=4b83a202&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b83a202",
  null
  
)

export default component.exports